module.exports = "<cm-header></cm-header>\n<router-outlet></router-outlet>\n<ng-snotify></ng-snotify>\n<cm-whatsapp-buttom></cm-whatsapp-buttom>"